import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        feedback: '='
    },
    template: `
        <div class="quiz-feedback">
            <h4>{{ 'feedback.Question feedback' | translate }}</h4>
            <div ng-bind-html="vm.feedback"></div>
        </div>
    `
})

export default class {

}



// WEBPACK FOOTER //
// ./src/app/components/quiz/question/feedback/index.js